export default "__VITE_ASSET__4a17905a__"